import { GroupDataFactory } from '../../jscaip/BoardData';
import { HexaDirection } from '../../jscaip/HexaDirection';
import { Orthogonal } from '../../jscaip/Orthogonal';
import { Vector } from '../../jscaip/Vector';
import { TriangularCheckerBoard } from '../../jscaip/state/TriangularCheckerBoard';
import { GoGroupData } from './GoGroupsData';
export class GoGroupDataFactory extends GroupDataFactory {
    getNewInstance(color) {
        return new GoGroupData(color, [], [], [], [], [], []);
    }
}
export class OrthogonalGoGroupDataFactory extends GoGroupDataFactory {
    zoom;
    constructor(zoom) {
        super();
        this.zoom = zoom;
    }
    getDirections(_) {
        return Orthogonal.ORTHOGONALS.map((value) => new Vector(0, 0).combine(value, this.zoom));
    }
}
export class TriangularGoGroupDataFactory extends GoGroupDataFactory {
    getDirections(coord) {
        return TriangularCheckerBoard.getDirections(coord);
    }
}
export class HexagonalGoGroupDataFactory extends GoGroupDataFactory {
    getDirections(_) {
        return HexaDirection.factory.all;
    }
}
